// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 593) return "static/chunks/framework-e64606a018f3795b.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"155":"0bd2f4cc","716":"98309536"}[chunkId] || chunkId) + "." + {"155":"32350f2361a1654b","407":"f83e8d4fdda659f7","716":"ea12896b6cee5d2b","962":"b3d386b6746e006e"}[chunkId] + ".js";
};